// TODO: Think builder. Should be conditional, depending on the type of filter
const model = {
    name: 'SearchFilter',
    properties: {
        // TODO: Adjust posible values of type property
        type: {},
        name: { required: true },
        values: { type: 'array', required: true },
    },
};
export default model;
